import React from 'react';
import Styles from './score.less';
import classNames from 'classnames';

export interface IScoreColor {
    textColor: string;
    circleColor: string;
}

// 不同档位的颜色配色
const scoreLevelColors: Array<IScoreColor> = [
    {
        textColor: '#007A41',
        circleColor: '#A3F0D4',
    },
    {
        textColor: '#E07800',
        circleColor: '#FFF2A3',
    },
    {
        textColor: '#EB4825',
        circleColor: '#FFD7BF',
    },
];

export interface IScoreProps {
    score: number;
}

export const Score: React.FC<IScoreProps> = (props: IScoreProps) => {
    const level = getColorLevelOfScore(props.score);
    const color = scoreLevelColors[level];
    return <svg
        className={classNames({
            [Styles['score-svg']]: true,
        })} viewBox="0 0 84 84">
        <circle
            r="42" cx="42" cy="42"
            fill={color.circleColor}
        />
        <text
            className={classNames({
                [Styles['score-text']]: true,
            })}
            x={42}
            y={45}
            fill={color.textColor}
        >
            {props.score}
        </text>
    </svg>;
};

function getColorLevelOfScore(score: number): number {
    if (score >= 90) return 0;
    if (score >= 60) return 1;
    return 2;
}
